import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import SearchPage from "@/pages/SearchPage";
import HostessDetail from "@/pages/HostessDetail";
import ProfileEditor from "@/pages/ProfileEditor";
import CreditsPage from "@/pages/CreditsPage";
import AdminPage from "@/pages/AdminPage";
import MessagesPage from "@/pages/MessagesPage";
import EventsBoard from "@/pages/EventsBoard";
import CreateEvent from "@/pages/CreateEvent";
import EventDetail from "@/pages/EventDetail";
import Dashboard from "@/pages/Dashboard";
import CityPage from "@/pages/CityPage";
import { Seo } from "@/components/Seo";

const Protected = ({ children, role }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[60vh] flex items-center justify-center eyebrow" data-testid="auth-loading">Caricamento…</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (role && ![].concat(role).includes(user.role)) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return <><Seo title="YourHostess" noindex />{children}</>;
};

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/accedi" element={<AuthPage />} />
            <Route path="/cerca" element={<SearchPage />} />
            <Route path="/hostess-a/:slug" element={<CityPage />} />
            <Route path="/hostess/:id" element={<HostessDetail />} />
            <Route path="/eventi" element={<EventsBoard />} />
            <Route path="/eventi/nuovo" element={<Protected role="client"><CreateEvent /></Protected>} />
            <Route path="/eventi/:id" element={<Protected><EventDetail /></Protected>} />
            <Route path="/profilo" element={<Protected role="hostess"><ProfileEditor /></Protected>} />
            <Route path="/messaggi" element={<Protected role={["client", "hostess"]}><MessagesPage /></Protected>} />
            <Route path="/messaggi/:id" element={<Protected role={["client", "hostess"]}><MessagesPage /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminPage /></Protected>} />
            <Route path="/crediti" element={<Protected role={["client", "hostess"]}><CreditsPage /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#181B20", border: "1px solid rgba(212,175,55,0.3)", color: "#F9F8F6", borderRadius: 2 } }} />
    </div>
  );
}

export default App;
